interface ToggleProps {
  enabled: boolean;
  onChange: (value: boolean) => void;
}

const Toggle = ({ enabled, onChange }: ToggleProps) => (
  <button
    type="button"
    role="switch"
    aria-checked={enabled}
    onClick={() => onChange(!enabled)}
    className={`relative h-4 w-8 rounded-xl transition-colors duration-200 focus:outline-none ${enabled ? "bg-brand-teal" : "bg-border-subtle"}`}
  >
    <span
      className="absolute top-[2px] h-3 w-3 rounded-xl bg-white transition-all duration-200"
      style={{ [enabled ? "right" : "left"]: "2px" }}
    />
  </button>
);

export default Toggle;
